export const INIT_APP = 'INIT_APP';
export const INIT_MODULE = 'INIT_MODULE';
